<template>
  <div :class="this.classes">
    <a :href="this.link" v-on:mouseenter="hover = true" v-on:mouseleave="hover = false">
      <img v-show="!this.hover"
           :src="this.originalImage.link"
           :title="this.originalImage.title"
           :alt="this.originalImage.alt" />
      <img v-show="this.hover"
           :src="this.flipImage.link"
           :title="this.flipImage.title"
           :alt="this.flipImage.alt" />
    </a>
  </div>
</template>

<script>
export default {
  name: "FlipImageLinkCard",
  props: {
    classes: String,
    link: {
      type: String,
      required: true
    },
    originalImage: {
      type: Object,
      required: true,
      default: function() {
        return {
          link: '',
          title: '',
          alt: ''
        }
      }
    },
    flipImage: {
      type: Object,
      required: true,
      default: function() {
        return {
          link: '',
          title: '',
          alt: ''
        }
      }
    }
  },
  data() {
    return {
      hover: false
    }
  }
}
</script>

<style scoped>

</style>